import React, { Fragment } from 'react';
import { FormGroup } from 'reactstrap';
import { H4, P, UL } from '../../../AbstractElements';
import SocialAuth from './SocialAuth';

const FormHeader = (props) => {
    const { selected = '' } = props;
    return (
        <Fragment>
            <div className='login-header text-center'>
                <H4>{'Sistem Informasi Keuangan'}</H4>
                <P>{'Selamat datang kembali, Silakan login ke dalam akun'}</P>
            </div>
            {/* <FormGroup>
                <UL attrUL={{ className: 'simple-list login-social1 flex-row' }}>
                    <SocialAuth />
                </UL>
            </FormGroup> */}
        </Fragment>
    );
};
export default FormHeader;